import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from '../../../services/config/config.service';
import { EcommerceService } from '../../../services/ecommerce/ecommerce.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-ecommerce',
  standalone: false,

  templateUrl: './ecommerce.component.html',
  styleUrl: './ecommerce.component.scss'
})
export class EcommerceComponent implements OnInit {
  load: boolean = false;
  loadMenu: boolean = true;
  token: any = {};
  infoUser: any = {};
  rangeDates: Date[] = [new Date(new Date().setDate(1)), new Date()];
  @ViewChild('calendar') calendar: any;
  items: Array<any> = [];
  itemsSuccess: Array<any> = [];
  viewResumen: boolean = false;
  totales: any = { subtotal: 0, taxes: 0, shippingCost: 0 };
  totalesSuccess: any = { subtotal: 0, taxes: 0, shippingCost: 0 };
  displayDetail: boolean = false;
  detail: Array<any> = [];

  constructor(private config: ConfigService, private ecommerce: EcommerceService) { }

  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoUser = JSON.parse(localStorage.getItem('infoUser') ?? "[]");

    this.getInfo();
  }

  onSelectDate = ($event: any) => {
    if (!!this.rangeDates[1]) {
      this.calendar.toggle();
      this.getInfo();
    }
  }

  getInfo = () => {
    this.totales = { subtotal: 0, taxes: 0, shippingCost: 0 };
    this.totalesSuccess = { subtotal: 0, taxes: 0, shippingCost: 0 };
    this.ecommerce.getSales(this.token.token, this.config.formatDateUnique(this.rangeDates[0]),
      this.config.formatDateUnique(this.rangeDates[1])).subscribe({
        next: (response) => {
          this.items = response as Array<any>;
          this.itemsSuccess = this.items.filter((row: any) => { return row.statusIntegration == 'Pago Recibido' });

          this.items.map((row: any) => {
            this.totales.subtotal = this.totales.subtotal + row.subtotal;
            this.totales.taxes = this.totales.taxes + row.taxes;
            this.totales.shippingCost = this.totales.shippingCost + row.shippingCost;
          })

          this.itemsSuccess.map((row: any) => {
            this.totalesSuccess.subtotal = this.totalesSuccess.subtotal + row.subtotal;
            this.totalesSuccess.taxes = this.totalesSuccess.taxes + row.taxes;
            this.totalesSuccess.shippingCost = this.totalesSuccess.shippingCost + row.shippingCost;
          })
        },
        error: (error: HttpErrorResponse) => { console.error(error); }
      })
  }

  viewDetail = (detail: any) => {
    this.displayDetail = true;
    this.detail = detail;
  }

}
